<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input size="small" v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input size="mini" v-model="searchForm.productName" clearable placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单来源" v-if="baseInfo.storeType === 10">
          <el-select size="small" v-model="searchForm.sourceType" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="我的订单" :value="1"></el-option>
            <el-option label="下游订单" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport" v-auth="'/order/operate/export'">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'待收货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%"
                  v-loading="loading">
          <el-table-column label="订单信息" min-width="500">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.isTopRow">
                <span class="state-text"
                      :class="{ 'state-text-red': scope.row.orderSource != 10 }">{{ scope.row.orderSourceText }}</span>
                <span class="c_main">订单号：{{ scope.row.orderNo }}</span>
                <span class="pl16">下单时间：{{ scope.row.createTime }}</span>
                <span class="pl16">订单类型：{{ scope.row.orderSourceText + '订单' }}</span>
                <span class="pl16">结算状态：{{ scope.row.isSettled === 0 ? '未出账' : '已结算' }}</span>
                <span class="pl16"
                      v-if="scope.row.isSelfOrder !== 1">订单来源：{{ getShowOrderSource(scope.row.isSelfOrder) }}</span>
                <span class="pl16"
                      v-if="scope.row.isSelfOrder === 3 && scope.row.agentName">分销商：{{ scope.row.agentName }}</span>
                <!--是否取消申请中-->
                <span class="pl16" v-if="scope.row.orderStatus == 21"><el-tag effect="dark"
                                                                              size="mini">取消订单中</el-tag></span>
                <span class="pl16"
                      v-if="scope.row.orderStatus == 21 && scope.row.cancelTime"> 申请时间：{{
                    scope.row.cancelTime
                  }}</span>
                <span class="pl16"
                      v-if="scope.row.orderStatus == 10 && scope.row.deliveryStatus==20 && scope.row.receiptStatus==10 && scope.row.logisticsStatus == 1 && scope.row.isSelfOrder === 1"><el-tag
                  effect="dark"
                  type="danger"
                  size="mini">异常订单</el-tag></span>
                <span class="pl16"
                      v-if="scope.row.wdtUploadStatus === 3 && scope.row.isSelfOrder === 1 && scope.row.orderStatus === 10 &&  scope.row.deliveryStatus==10  && scope.row.payStatus==20"><el-tag
                  effect="dark"
                  type="warning"
                  size="mini">延迟推送中...</el-tag></span>
                <!--                <span class="fr" style="color: red">打印发货单</span>-->
              </div>
              <template v-else>
                <div class="product-info" v-for="(item, index) in scope.row.productList" :key="index">
                  <div class="pic"><img v-img-url="item.imagePath" alt=""/></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.productName }}</span>
                    </div>
                    <div class="d-s-c">
                      <div class="gray9 pr16" v-if="item.productAttr">{{ item.productAttr }}</div>
                      <div class="orange pr16">￥ {{ item.productPrice }}</div>
                      <div class="gray3">x{{ item.totalNum }}</div>
                    </div>
                    <div class="orange" v-if="item.refund">{{ item.refund.type.text }}-{{
                        item.refund.status.text
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="orderPrice" align="center" label="订单金额" :min-width="100">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="orange">{{ scope.row.orderPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" align="center" label="支付总价" :min-width="120">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="orange">{{ scope.row.payPrice }}</div>
              <p class="gray9">(含运费：{{ scope.row.expressPrice }})</p>
              <p class="gray9"> {{ scope.row.payTypeText }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" label="买家" :min-width="120">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <!--              <div> {{ scope.row.address.region ? scope.row.address.region.province || '' : '' }}-->
              <!--                {{ scope.row.address.region ? scope.row.address.region.city || '' : '' }}-->
              <!--                {{ scope.row.address.region ? scope.row.address.region.region || '' : '' }}-->
              <!--                {{ scope.row.address.detail || '' }}-->
              <!--              </div>-->
              <!--              <div>{{ scope.row.address.name || '' }}</div>-->
              <!--              <div>{{ scope.row.address.phone || '' }}</div>-->
              <div>{{ scope.row.nickname }}</div>
              <div class="gray9">{{ scope.row.mobile }}</div>
            </template>
          </el-table-column>
          <el-table-column label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="table-btn-column">
                <div :style="{color:getShowStatusColor(scope.row)}">{{ scope.row.orderStatusText }}</div>
                <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情
                </el-button>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="pay_type.text" label="支付方式">-->
          <!--            <template slot-scope="scope" v-if="!scope.row.isTopRow">-->
          <!--              <span class="gray9">{{ scope.row.payTypeText }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="delivery_type.text" label="配送方式">-->
          <!--            <template slot-scope="scope" v-if="!scope.row.isTopRow">-->
          <!--              <span class="green">{{ scope.row.deliveryTypeText }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="评价" width="60">-->
          <!--            <template slot-scope="scope" v-if="!scope.row.isTopRow">-->
          <!--              <span v-if="scope.row.isComment == 0">未评价</span>-->
          <!--              <span v-else="">已评价</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="table-btn-column">
                <el-button
                  class="m-v-2"
                  v-if="scope.row.payStatus === 20 && scope.row.deliveryStatus === 10 && scope.row.orderStatus !== 20 && scope.row.orderStatus !== 21  && scope.row.isSelfOrder === 1 && hasWDTConfig === 1"
                  @click="clickOrder2ERPDelivery(scope.row)"
                  type="danger"
                  size="small"
                  v-auth="'/order/order/delivery'"
                >
                  <div class="p-h-10 p-v-5">推单ERP</div>
                </el-button>
                <el-button
                  class="m-v-2"
                  v-if="scope.row.payStatus === 20 && scope.row.deliveryStatus === 10 && scope.row.orderStatus !== 20 && scope.row.orderStatus !== 21  && scope.row.isSelfOrder === 1"
                  @click="clickDelivery(scope.row)"
                  type="danger"
                  size="small"
                  v-auth="'/order/order/delivery'"
                >
                  <div class="p-h-10 p-v-5">我要发货</div>
                </el-button>

                <el-button
                  class="m-v-2"
                  v-if="scope.row.payStatus == 20 && scope.row.deliveryStatus == 20 && scope.row.orderStatus == 10   && scope.row.isSelfOrder == 1"
                  @click="clickRefreshDelivery(scope.row)"
                  type="danger"
                  size="small"
                  v-auth="'/order/order/delivery'"
                >
                  <div class="p-h-10 p-v-5">更新物流单</div>
                </el-button>

                <el-button
                  class="m-v-2"
                  v-if="scope.row.payStatus == 20 && scope.row.deliveryStatus == 10 && scope.row.orderStatus != 20 && scope.row.orderStatus != 21 "
                  @click="clickInvoice(scope.row)"
                  type="primary"
                  v-auth="'/order/order/delivery'"
                >
                  <div class="p-h-10 p-v-5">上传发票</div>
                </el-button>

                <el-button
                  class="m-v-2"
                  v-if="scope.row.deliveryType == 20 && scope.row.payStatus == 20 && scope.row.deliveryStatus == 20 && scope.row.orderStatus != 30 && scope.row.orderStatus != 20 && (scope.row.isSelfOrder == 2 || scope.row.shopSupplierId === scope.row.agentId)"
                  @click="clickExtract(scope.row)"
                  type="warning"
                  v-auth="'/order/operate/extract'"
                >
                  <div class="p-h-10 p-v-5">我要核销</div>
                </el-button>
                <el-button
                  class="m-v-2"
                  v-if="scope.row.payStatus == 20 && scope.row.deliveryStatus == 10 && scope.row.orderStatus == 10 && (scope.row.isSelfOrder === 1 || scope.row.isSelfOrder === 2)"
                  @click="cancelClick(scope.row)"
                  type="info"
                  v-auth="'/order/operate/confirmCancel'"
                >
                  <div class="p-h-10 p-v-5">取消订单</div>
                </el-button>
                <el-button
                  v-if="scope.row.orderStatus == 21 && (scope.row.isSelfOrder === 1 || scope.row.isSelfOrder === 2)"
                  @click="onConfirmClick(scope.row)" type="primary"
                  v-auth="'/order/operate/confirmCancel'">
                  <div class="p-h-10 p-v-5">审核订单</div>
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogDelivery" width="30%">
      <div class="pb16">
        <span class="gray9">订单号：</span>
        <span>{{ deliveryForm.orderNo }}</span>
      </div>
      <div class="pb16">
        <span class="gray9">物流公司：</span>
        <el-select v-model="deliveryForm.expressId" placeholder="请选择快递公司">
          <el-option :label="item.expressName" v-for="(item, index) in expressList" :key="index"
                     :value="item.expressId"></el-option>
        </el-select>
      </div>
      <div class="pb16">
        <span class="gray9">物流单号：</span>
        <div v-for="(item,index) in deliveryExpressNoList" class="m-v-5" :key="index">
          <el-input v-model="item.no" class="max-w460"></el-input>
          <span class="m-l-10" @click="onDeliveryExpressAddClick(deliveryExpressNoList,index)" style="cursor: pointer"
                v-if="index === deliveryExpressNoList.length-1"><i class="el-icon-circle-plus fs-18"></i></span>
          <span class="m-l-10" @click="onDeliveryExpressDeleteClick(deliveryExpressNoList,index)"
                style="cursor: pointer"
                v-if="index !== deliveryExpressNoList.length-1"><i class="el-icon-remove fs-18"></i></span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogDelivery=false">取 消</el-button>
        <el-button size="small" type="primary" @click="deliverySubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="我要核销" :visible.sync="dialogExtract" width="30%">
      <div class="pb16">
        <span class="gray9">订单号：</span>
        <span>{{ extractForm.orderNo }}</span>
      </div>
      <div class="pb16">
        <span class="gray9">核销专员：</span>
        <el-select v-model="extractForm.extractClerkId" placeholder="点击选择">
          <el-option :label="item.realName" v-for="(item, index) in shopClerkList" :key="item.clerkId"
                     :value="item.clerkId"></el-option>
        </el-select>
      </div>
      <div class="pb16">
        <span class="gray9">买家取货状态：</span>
        <el-radio v-model="extractForm.extractStatus" :label="1">已取货</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogExtract=false">取 消</el-button>
        <el-button size="small" type="primary" @click="extractSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="上传发票" :visible.sync="dialogInvoice" width="30%">
      <div class="pb16">
        <span class="gray9">订单号：</span>
        <span>{{ invoiceForm.orderNo }}</span>
      </div>
      <div class="pb16 flex j-start a-start">
        <span class="gray9">上传发票：</span>
        <div style="min-width: 100px;height: 100px" class="border flex a-center j-center" @click="isupload=true">
          <i class="el-icon-plus" v-if="!invoiceForm.invoicePath"></i>
          <img style="height: 100%" :src="invoiceForm.invoicePath" alt="" v-if="invoiceForm.invoicePath">
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogInvoice=false">取 消</el-button>
        <el-button size="small" type="primary" @click="invoiceSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="审核订单" :visible.sync="dialogConfirm" width="30%">
      <!--      <div class="common-form mt16">用户取消订单</div>-->
      <p class="red pb16">
        当前买家已付款并申请取消订单，请审核是否同意，如同意则自动退回付款金额（微信支付原路退款）并关闭订单。</p>
      <el-form size="small" ref="confirmForm" :model="confirmForm">
        <el-form-item label="审核状态">
          <div>
            <el-radio v-model="confirmForm.isCancel" :label="1">同意</el-radio>
            <el-radio v-model="confirmForm.isCancel" :label="0">拒绝</el-radio>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogConfirm=false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmCancel">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量发货说明" :visible.sync="dialogBatchDelivery" width="30%">
      <div>1、先按未发货条件筛选后，导出订单</div>
      <div>2、在导出excel中填写物流公司、物流单号，然后点批量发货导入填好的excel文件</div>
      <div>
        3、请检查物流公司是否已经添加到系统，
        <el-link type="primary" :underline="false" @click="gotoExpress()">查看</el-link>
      </div>
      <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action="string"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :before-upload="onBeforeUploadImage"
          :http-request="UploadImage"
          :show-file-list="false"
        >
          <el-button size="small" icon="el-icon-upload" type="primary">上传发货表格</el-button>
        </el-upload>
      </div>
    </el-dialog>
    <!--处理-->
    <Cancel v-if="open_edit" :open_edit="open_edit" :order_no="order_no"
            @closeDialog="closeDialogFunc($event, 'edit')"></Cancel>

    <Upload v-if="isupload" :config="{ total: 1 }" @returnImgs="returnImgsFunc"></Upload>

    <el-dialog title="推单ERP" :visible.sync="dialogWDT" width="50%">
      <div class="pb16">
        <span class="gray9">订单号：</span>
        <span>{{ WDTForm.orderNo }}</span>
      </div>
      <div class="pb16">
        <span class="gray9">收货地址:</span>
        {{ WDTForm.address.region ? WDTForm.address.region.province || '' : '' }}
        {{ WDTForm.address.region ? WDTForm.address.region.city || '' : '' }}
        {{ WDTForm.address.region ? WDTForm.address.region.region || '' : '' }}
        {{ WDTForm.address.detail || '' }}
      </div>
      <div class="pb16">
        <span class="gray9">收货人：</span>
        {{ WDTForm.address.name }} / {{ WDTForm.address.phone }}
      </div>
      <div class="pb16">
        <span class="gray9">买家留言：</span>
        {{ WDTForm.buyerRemark }}
      </div>
      <div class="table-wrap">
        <el-table size="small" :data="WDTForm.orderProductLst" border style="width: 100%">
          <el-table-column prop="productName" label="商品" width="400">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath"/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">
                    <span>￥ {{ scope.row.productPrice }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="productNo" label="商品编码"></el-table-column>
          <el-table-column prop="specNo" label="规格码"></el-table-column>
          <el-table-column prop="productWeight" label="重量 (Kg)"></el-table-column>
          <el-table-column prop="totalNum" label="购买数量">
            <template slot-scope="scope">
              <p>x {{ scope.row.totalNum }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="sysMoney" label="平台抽成(元)">
          </el-table-column>
        </el-table>
      </div>
      <div class="pb16 m-t-10">
        <span class="gray9">运费金额 (元)：</span>
        {{ WDTForm.expressPrice }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogWDT=false">取 消</el-button>
        <el-button size="small" type="primary" @click="WDTSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import OrderApi from '@/api/order.js'
import qs from 'qs'
import {getCookie} from '@/utils/base.js'
import Cancel from './dialog/cancel.vue'
import Upload from '../../../components/file/Upload'

export default {
  name: 'orderList',
  components: {
    Upload,
    Cancel
  },
  props: {
    orderType: {
      type: Number,
      default: 1
    },
    activityId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'getPageType': {
      handler (newValue) {
        if (newValue.orderType === 2 && newValue.activityId) {
          this.getData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    getPageType () {
      return {
        orderType: this.orderType,
        activityId: this.activityId,
      }
    }
  },
  data () {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        orderNo: '',
        style_id: '',
        store_id: '',
        sourceType: '',
        createTime: '',
        productName: ''
      },
      /*配送方式*/
      exStyle: [],
      /*提货站点列表*/
      shopList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      dialogBatchDelivery: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      order_no: '',
      /*快递公司列表*/
      expressList: [],
      dialogDelivery: false,
      deliveryForm: {
        orderId: 0,
        orderNo: '',
        expressId: null,
        expressNo: ''
      },
      deliveryExpressNoList: [{no: ''}],
      dialogExtract: false,
      shopClerkList: [],
      extractForm: {
        orderId: 0,
        orderNo: '',
        extractClerkId: null,
        extractStatus: 1
      },
      dialogInvoice: false,
      invoiceForm: {
        orderId: 0,
        orderNo: '',
        invoiceId: null,
        invoicePath: ''
      },
      dialogConfirm: false,
      hasWDTConfig: 0,
      confirmForm: {
        orderId: 0,
        isCancel: 1
      },
      isupload: false,
      title: '我要发货',
      optate: 1,
      dialogWDT: false,
      WDTForm: {
        orderId: 0,
        orderNo: '',
        address: {}
      }
    }
  },
  inject: ['baseInfo'],
  created () {
    /*获取列表*/
    if (this.orderType === 1) {
      this.getData()
    }
  },
  methods: {
    /*跨多列*/
    arraySpanMethod (row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8]
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      let search = this.searchForm
      let Params = {}
      Params.dataType = self.activeName
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      if (search.createTime && search.createTime.length) {
        Params.startDate = search.createTime[0]
        Params.endDate = search.createTime[1]
      }
      if (search.productName) {
        Params.productName = search.productName
      }
      Params.orderNo = search.orderNo
      Params.deliveryType = search.style_id
      if (this.activityId) {
        Params.activityId = this.activityId
      }
      if (search.sourceType) {
        Params.sourceType = search.sourceType
      }
      self.loading = true
      OrderApi.orderlist(Params, true)
        .then(res => {
          let list = []
          for (let i = 0; i < res.data.orderList.records.length; i++) {
            let item = res.data.orderList.records[i]
            let topitem = {
              orderNo: item.orderNo,
              createTime: item.createTime,
              orderSource: item.orderSource,
              orderSourceText: item.orderSourceText,
              orderStatus: item.orderStatus,
              isSettled: item.isSettled,
              isSelfOrder: item.isSelfOrder,
              isTopRow: true,
              agentName: item.agentName,
              cancelTime: item.cancelTime,
              deliveryStatus: item.deliveryStatus,
              receiptStatus: item.receiptStatus,
              logisticsStatus: item.logisticsStatus,
              wdtUploadStatus: item.wdtUploadStatus,
              payStatus: item.payStatus
            }
            list.push(topitem)
            list.push(item)
          }
          self.tableData.data = list

          self.totalDataNumber = res.data.orderList.total
          self.exStyle = res.data.deliveryList
          self.expressList = res.data.expressList
          self.order_count = res.data.orderCount
          self.hasWDTConfig = res.data.hasWDTConfig || 0
          self.loading = false
        })
        .catch(error => {
        })
    },
    /*打开取消*/
    cancelClick (item) {
      this.order_no = item.orderNo
      this.open_edit = true
    },
    /*关闭弹窗*/
    closeDialogFunc (e, f) {
      if (f == 'edit') {
        this.open_edit = e.openDialog
        if (e.type == 'success') {
          this.getData()
        }
      }
    },
    /*打开添加*/
    addClick (row) {
      let self = this
      let params = row.orderId
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          orderId: params
        }
      })
    },

    onConfirmClick (row) {
      this.confirmForm = {
        orderId: row.orderId,
        isCancel: 1
      }
      this.dialogConfirm = true
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.tableData = []
      this.getData()
    },
    onExport: function () {
      let self = this
      let search = this.searchForm
      let Params = {}
      Params.dataType = self.activeName
      Params.startDate = search.createTime[0]
      Params.endDate = search.createTime[1]
      Params.token = getCookie('token_supplier')
      // let baseUrl = window.location.protocol + '//' + window.location.host
      window.location.href = process.env.BASE_API + 'supplier/order/operate/export?' + qs.stringify(Params)
    },
    // 显示批量发货说明
    showBatchDelivery () {
      this.dialogBatchDelivery = true
    },
    /*跳转物流公司*/
    gotoExpress () {
      let self = this
      self.$router.push('/setting/express/index')
    },

    /*选择图片之前*/
    onBeforeUploadImage (file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isEXCEL = fileType === 'xlsx'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      return isEXCEL && isLt10M
    },

    /*上传图片*/
    UploadImage (param) {
      let self = this
      const loading = this.$loading({
        lock: true,
        text: '正在处理,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const formData = new FormData()
      formData.append('iFile', param.file)
      OrderApi.batchDelivery(formData)
        .then(response => {
          loading.close()
          self.dialogBatchDelivery = false
          self.$message({
            message: response.msg,
            type: 'warning'
          })
        })
        .catch(response => {
          loading.close()
          self.$message({
            message: '本次处理失败',
            type: 'warning'
          })
          param.onError()
        })
    },
    getShowStatusColor (row) {
      let text = ''
      let orderStatus = row.orderStatus
      let payStatus = row.payStatus
      let deliveryStatus = row.deliveryStatus
      if (orderStatus === 20) {
        return '#999999'
      }
      if (orderStatus === 30) {
        return '#333333'
      }

      if (payStatus === 10) {
        return '#FF453A'
      }

      if (deliveryStatus === 10) {
        return '#FF9500'
      }

      if (deliveryStatus === 20) {
        return '#FFCC00'
      }
      return text
    },
    clickDelivery (row) {
      this.optate = 1
      this.deliveryExpressNoList = [{no: ''}]
      this.deliveryForm = {
        orderId: row.orderId,
        orderNo: row.orderNo,
        /*订单ID*/
        expressId: null,
        /*订单号*/
        expressNo: ''
      }
      this.title = '我要发货'
      this.dialogDelivery = true
    },
    clickOrder2ERPDelivery (row) {
      this.WDTForm = {
        orderId: row.orderId,
        orderNo: row.orderNo,
        orderProductLst: row.productList,
        address: row.address,
        nickname: row.nickname || '',
        mobile: row.mobile,
        buyerRemark: row.buyerRemark,
        expressPrice: row.expressPrice
      }
      this.dialogWDT = true
    },
    WDTSubmit () {
      let self = this
      let param = self.WDTForm
      if (!param.orderId || param.orderId < 1) {
        return this.$message.error('订单错误')
      }
      OrderApi.orderPushToErp(param, true).then(data => {
        self.$message({
          message: '恭喜你，推单成功',
          type: 'success'
        })
        self.getData()
        this.dialogWDT = false
      }).catch(error => {
      })
    },
    clickRefreshDelivery (row) {
      this.optate = 2
      this.deliveryExpressNoList = [{no: ''}]
      if (row.expressNo) {
        let deliveryExpressNoList = row.expressNo.split(',')
        this.deliveryExpressNoList = deliveryExpressNoList.map(item => {
          return {
            no: item || ''
          }
        })
      }
      this.deliveryForm = {
        orderId: row.orderId,
        orderNo: row.orderNo,
        /*订单ID*/
        expressId: row.expressId || null,
        /*订单号*/
        expressNo: row.expressNo || ''
      }
      this.title = '更新物流单号'
      this.dialogDelivery = true
    },
    deliverySubmit () {
      let self = this
      let param = self.deliveryForm
      if (param.expressId == null || param.expressId < 1) {
        this.$message.error('请选择物流公司')
        return
      }

      if (!(this.deliveryExpressNoList && this.deliveryExpressNoList.length)) {
        this.$message.error('请填写物流单号')
        return
      }
      param.expressNo = this.deliveryExpressNoList.map(res => res.no).join(',')
      if (this.optate === 1) {
        OrderApi.delivery(param, true).then(data => {
          self.$message({
            message: '恭喜你，发货成功',
            type: 'success'
          })
          self.getData()
          this.dialogDelivery = false
        }).catch(error => {
        })
      } else if (this.optate === 2) {
        OrderApi.updateDeliveryNo(param, true).then(data => {
          self.$message({
            message: '恭喜你，更新成功',
            type: 'success'
          })
          self.getData()
          this.dialogDelivery = false
        }).catch(error => {
        })
      }
    },
    clickExtract (row) {
      this.shopClerkList = row.shopClerkList || []
      this.extractForm = {
        orderId: row.orderId,
        orderNo: row.orderNo,
        extractClerkId: null,
        extractStatus: 1
      }
      this.dialogExtract = true
    },
    extractSubmit () {
      let self = this
      let param = self.extractForm
      if (!param.extractClerkId || param.extractClerkId < 1) {
        return this.$message.error('请选择核销专员')
      }
      OrderApi.extract(param, true)
        .then(data => {
          self.$message({
            message: '恭喜你，操作成功',
            type: 'success'
          })
          self.getData()
          this.dialogExtract = false
        })
        .catch(error => {
        })

    },
    clickInvoice (row) {
      this.invoiceForm = {
        orderId: row.orderId,
        orderNo: row.orderNo,
        invoiceId: row.invoiceId || null,
        invoicePath: row.invoicePath || ''
      }
      this.dialogInvoice = true
    },
    invoiceSubmit () {
      let self = this
      let param = self.invoiceForm
      if (!param.invoiceId || param.invoiceId < 1) {
        return this.$message.error('请选择发票')
      }
      OrderApi.invoice(param, true)
        .then(data => {
          self.$message({
            message: '恭喜你，操作成功',
            type: 'success'
          })
          self.getData()
          this.dialogInvoice = false
        })
        .catch(error => {
        })
    },
    /*确认取消*/
    confirmCancel () {
      let self = this
      let param = self.confirmForm
      OrderApi.confirm(param, true)
        .then(data => {
          self.$message({
            message: '恭喜你，审核成功',
            type: 'success'
          })
          self.getData()
          self.dialogConfirm = false
        })
        .catch(error => {

        })
    },

    onDeliveryExpressAddClick (list, index) {
      list.push({no: ''})
    },
    onDeliveryExpressDeleteClick (list, index) {
      list.splice(index, 1)
    },
    returnImgsFunc (e) {
      if (e != null) {
        this.invoiceForm.invoiceId = e[0].fileId
        this.invoiceForm.invoicePath = e[0].filePath
      }
      this.isupload = false
    },
    getShowOrderSource (isSelfOrder) {
      let text = ''
      if (isSelfOrder === 2) {
        text = '我的订单'
      } else if (isSelfOrder === 3) {
        text = '下游订单'
      }
      return text
    }
  }
}
</script>
<style lang="scss">
.product-info {
  padding: 5px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/orderlist.vue